import { FORGOT_PASSWORD_STORE, TYPE_KEY } from "../common/constant";
import rest from "../common/rest";
import { beginLoading, endLoading } from "./loadingSpinner";
import { createErrorMessages, createSuccessMessages, messagesReceived } from "./message";
import { MAX_PASSWORD_CHARS, MIN_PASSWORD_CHARS } from "./userManagement";

const REDUCER = "FORGOTPASSWORD.";

// action keys
const PROPERTY_CHANGED_ACTION = REDUCER + "PROPERTY_CHANGED_ACTION";

export const PROPERTY_NAME = "propertyName";
export const PROPERTY_VALUE = "propertyValue";

// store attribute keys
export const USERNAME = "username";
export const NEW_PASSWORD = "newPassword";
export const NEW_PASSWORD_CONFIRM = "newPasswordConfirm";
export const NEW_PASSWORD_IS_VALID = "newPasswordIsValid";
export const NEW_PASSWORD_CONFIRM_IS_VALID = "newPasswordConfirmIsValid";
export const TOKEN_INVALID = "tokenInvalid";
export const TOKEN = "token";
export const PASSWORD_RESETTED_SUCCESSFULLY = "passwordResettedSuccessfully";
export const TOKEN_SENT_SUCCESSFULLY = "tokenSentSuccessfully";

const initialState = {
  [USERNAME]: undefined,
  [NEW_PASSWORD_IS_VALID]: true,
  [NEW_PASSWORD_CONFIRM_IS_VALID]: true,
  [TOKEN]: undefined,
  [TOKEN_INVALID]: false,
  [PASSWORD_RESETTED_SUCCESSFULLY]: undefined,
  [TOKEN_SENT_SUCCESSFULLY]: undefined
};

export default function reducer(state = initialState, action) {
  let newState;
  switch (action[TYPE_KEY]) {
    case PROPERTY_CHANGED_ACTION:
      newState = Object.assign({}, state, {
        [action[PROPERTY_NAME]]: action[PROPERTY_VALUE]
      });
      break;
    default:
      newState = Object.assign({}, state, {});
      break;
  }

  return newState;
}

export function propertyChange(propertyName, propertyValue) {
  return (dispatch, getState) => {
    const state = getState()[FORGOT_PASSWORD_STORE];
    const password = state[NEW_PASSWORD];
    const passwordConfirm = state[NEW_PASSWORD_CONFIRM];

    if (propertyName === NEW_PASSWORD_CONFIRM) {
      dispatch({
        [TYPE_KEY]: PROPERTY_CHANGED_ACTION,
        [PROPERTY_NAME]: NEW_PASSWORD_CONFIRM_IS_VALID,
        [PROPERTY_VALUE]: password === propertyValue
      });
    }

    if (propertyName === NEW_PASSWORD && propertyValue !== undefined) {
      const valid =
        password !== undefined &&
        propertyValue.length >= MIN_PASSWORD_CHARS &&
        propertyValue.length <= MAX_PASSWORD_CHARS;
      dispatch({
        [TYPE_KEY]: PROPERTY_CHANGED_ACTION,
        [PROPERTY_NAME]: NEW_PASSWORD_IS_VALID,
        [PROPERTY_VALUE]: valid
      });
      dispatch({
        [TYPE_KEY]: PROPERTY_CHANGED_ACTION,
        [PROPERTY_NAME]: NEW_PASSWORD_CONFIRM_IS_VALID,
        [PROPERTY_VALUE]: passwordConfirm === propertyValue
      });
    }

    if(propertyValue !== undefined) {
        dispatch({
          [TYPE_KEY]: PROPERTY_CHANGED_ACTION,
          [PROPERTY_NAME]: propertyName,
          [PROPERTY_VALUE]: propertyValue
        });
    }
  };
}

export function requestPasswordReset() {
  return (dispatch, getState) => {
    const state = getState()[FORGOT_PASSWORD_STORE];

    dispatch(beginLoading());

    rest.doPut(`/authentication/public/passwordresetrequest`, state[USERNAME]).then(
      (json) => {
        dispatch(endLoading());
        dispatch(propertyChange(TOKEN_SENT_SUCCESSFULLY, true));
        dispatch(propertyChange(USERNAME, undefined));
        dispatch(messagesReceived(createSuccessMessages("login.password.reset.request.success.message")));
      },
      (request) => {
        dispatch(endLoading());
        if (request.status === 403) {
          dispatch(messagesReceived(createErrorMessages("login.password.reset.temporary.user")));
        } else if (request.status === 404) {
          dispatch(messagesReceived(createErrorMessages("login.password.reset.user.not.found.or.inactive")));
        } else if (request.status === 504) {
          dispatch(messagesReceived(createErrorMessages("login.password.reset.request.timeout")));
        } else {
          dispatch(messagesReceived(createErrorMessages("login.password.reset.request.error")));
        }
      }
    );
  };
}

export function resetPassword() {
  return (dispatch, getState) => {
    const state = getState()[FORGOT_PASSWORD_STORE];

    const data = {
      token: state[TOKEN],
      newPassword: state[NEW_PASSWORD]
    };

    rest.doPut(`/authentication/public/passwordreset`, JSON.stringify(data)).then(
      (json) => {
        dispatch(propertyChange(PASSWORD_RESETTED_SUCCESSFULLY, true));
        dispatch(propertyChange(USERNAME, undefined));
        dispatch(propertyChange(NEW_PASSWORD, undefined));
        dispatch(propertyChange(NEW_PASSWORD_CONFIRM, undefined));
        dispatch(messagesReceived(createSuccessMessages("login.password.resetted.success.message")));
      },
      (request) => {
        const message = request.status === 403
          ? "login.password.reset.temporary.user"
          : "user.profile.reponse.error." + request.response;
        dispatch(messagesReceived(createErrorMessages(message)));
      }
    );
  };
}

export function validateToken(token) {
  return (dispatch) => {
    rest.doPost(`/authentication/public/validatetoken`, token).then(
      (json) => {
        dispatch(propertyChange(TOKEN, token));
      },
      (request) => {
        dispatch(propertyChange(TOKEN_INVALID, true));
        dispatch(messagesReceived(createErrorMessages("login.token.validation.failed.message")));
      }
    );
  };
}
